import { useOperation } from "@eusoft/webapp-ui";
import { context } from "./Context";
import type { ContextEntityFeature, ContextEntityType} from "./Context";
import type { SalePointType } from "../entities/Commands";
import type { IFeature, IContent} from "@eusoft/webapp-ui";


export function WithContext(type: "sale-point", feature?: SalePointType): IFeature<IContent>;

export function WithContext(type: ContextEntityType): IFeature<IContent>;

export function WithContext(type: ContextEntityType, feature?: ContextEntityFeature) : IFeature<IContent> {

    const result: IFeature<IContent> = (page: IContent) => useOperation(async () => {

        if (type == "sale-point")
            return await context.ensureSalePointAsync(feature);

        if (type == "sale-circuit")
            return await context.ensureSaleCircuitAsync();


        if (type == "merchant")
            return await context.ensureMerchantAsync(feature);

        return true;

    }, {
        name: "WithContext",
        unblock: true
    });

    result.type = "WithContext";
    result.data = {
        type,
        feature
    }

    return result;
}